export const sanitiseString = (str: string): string => {
  if (!str) {
    return '';
  }

  // Replace all non-alphanumeric characters with a hyphen
  return str.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();
};